<script setup lang="ts">
import { CardProps } from './Card.vue'
type CardPanelSwitcherProps = {
  variant?: string
  cards: CardProps[]
}

const props = defineProps<CardPanelSwitcherProps>()
const cards = filterPublished(props.cards)

const currentComponent = computed(() => {
  switch (props.variant) {
    case '2upPanel':
      return resolveComponent('TwoUpCardPanel')
    case '3upPanel':
      return resolveComponent('ThreeUpCardPanel')
    case 'proofPoint':
      return resolveComponent('ProofPointPanel')
    case '6upPanel':
      return resolveComponent('SixUpCardPanel')
    case 'product':
      return resolveComponent('FourUpCardPanel')
    case 'teaser':
    case 'basicTeaser':
    case 'productTeaser':
      return resolveComponent('TeaserCardPanel')
    default:
      return resolveComponent('Undefined')
  }
})
</script>

<template>
  <component :is="currentComponent" v-bind="{ variant, cards, ...$attrs }" />
</template>
